import React, { useState, useRef, useEffect, useMemo } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Modal from 'meinian-package/src/baseComponent/modal'
import Button from 'meinian-package/src/baseComponent/button'
import { SelectDisplay } from 'meinian-package/src/baseComponent/select/display'
import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import classNames from 'classnames'
import { useClickAway, useLatest } from 'ahooks'
import cloneDeep from 'lodash/cloneDeep'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import globalData from 'meinian-package/src/common/globalData'
import styles from './index.module.less'

const RANK_OPTIONS = [{ label: '最新采集', value: '1-0' }, { label: '最早采集', value: '1-1' }, { label: '最近更新', value: '2-0' }, { label: '最近发布', value: '3-0' }]
export const RANK_DEFAULT_VALUE = { rankStatus: 1, sortOrderStatus: 0 }

const configKeys = [
  { value: PLATFORM_VALUE.ITEM, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.ITEM).label },
  { value: PLATFORM_VALUE.DY, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.DY).label },
  { value: PLATFORM_VALUE.XIAOHONGSHU, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.XIAOHONGSHU).label },
  { value: PLATFORM_VALUE.INS, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.INS).label },
  { value: PLATFORM_VALUE.DW_GOODS, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.DW_GOODS).label },
  { value: PLATFORM_VALUE.CROSSBORDER, label: PLATFORM_CONFIG_ENUM.get(PLATFORM_VALUE.CROSSBORDER).label },
]
const config = new Map([
  [PLATFORM_VALUE.ITEM, [{ label: '销量最多', value: '10-0' }, { label: '月销量最多', value: '7-0' }, { label: '收藏量最多', value: '6-0' }]],
  [PLATFORM_VALUE.DY, [{ label: '销量最多', value: '10-0' }, { label: '月销量最多', value: '7-0' }]],
  [PLATFORM_VALUE.XIAOHONGSHU, [{ label: '点赞最多', value: '4-0' }, { label: '评论最多', value: '5-0' }, { label: '收藏最多', value: '6-0' }]],
  [PLATFORM_VALUE.INS, [{ label: '点赞最多', value: '4-0' }, { label: '评论最多', value: '5-0' }]],
  [PLATFORM_VALUE.DW_GOODS, [{ label: '销量最多', value: '10-0' }, { label: '评论最多', value: '5-0' }]],
  [PLATFORM_VALUE.CROSSBORDER, [{ label: '月销量最多', value: '7-0' }, { label: '评论最多', value: '5-0' }]],
])

export default ({
  placeholder = '排序',
  onClear,
  value,
  displayTextClassName,
  className,
  displayStyle,
  platformId,
  options = RANK_OPTIONS,
  onChange,
}) => {
  return <ExtendSelect
    allowClear={false}
    displayStyle={displayStyle}
    className={className}
    options={options}
    displayTextClassName={displayTextClassName}
    value={`${value.rankStatus}-${value.sortOrderStatus}`}
    placeholder={placeholder}
    onClear={onClear}
    platformId={platformId}
    onChange={(v, cur, extend) => onChange({
      rankStatus: v.split('-')[0],
      sortOrderStatus: v && v.split('-')[1],
      platformId: extend?.value || platformId
    })}
  />
}

const ExtendSelect = ({
  placeholder,
  onClear,
  value,
  allowClear,
  displayTextClassName,
  className,
  displayStyle,
  options,
  platformId,
  onChange
}) => {
  const platformIdHidTipKey = 'mn-extend-platformIdHidTip-1'
  const [platformIdHidTip, setPlatformIdHidTip] = useState(0)
  const latestPlatformIdHidTip = useLatest(platformIdHidTip)
  const [extendOpen, setExtendOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const domRef = useRef(null)

  useClickAway(() => {
    setVisible(false)
  }, domRef)

  useEffect(() => {
    !visible && setExtendOpen(false)
    globalData.get(platformIdHidTipKey, setPlatformIdHidTip, 0)
  }, [visible])

  const _options = useMemo(() => {
    if (platformId && config.has(platformId)) {
      const _platformIdOptions = cloneDeep(config.get(platformId)).map(item => ({ ...item, label: `${item.label}(${PLATFORM_CONFIG_ENUM.get(platformId).label})`, type: 'extend' }))

      // const curPlatformIdItem = cloneDeep(config.get(platformId).find(item => item.value === value))
      if (_platformIdOptions.length) {
        // curPlatformIdItem.label = `${curPlatformIdItem.label}(${PLATFORM_CONFIG_ENUM.get(platformId).label})`
        return options.concat(_platformIdOptions)
      }
      return options
    }
    return options
  }, [platformId, value])

  const _onChange = async (item, extendItem) => {
    if (!platformIdHidTip) {
      const dialog = await Modal.show({
        content: `选择该排序规则，将自动筛选${extendItem.label}`,
        footer: <div className="df-center-space-between">
          <div className="df-center"><Checkbox
            checked={!!platformIdHidTip}
            onChange={(e) => {
              setPlatformIdHidTip(e.target.checked ? 1 : 0)
            }}
          /><span className="ml8">不再提醒</span></div>
          <span>
            <Button className="mn-modal-confirm-footer-btn" onClick={() => dialog.destroy()}>取消</Button>
            <Button
              className="mn-modal-confirm-footer-btn ml8"
              type="primary"
              onClick={() => {
                globalData.set(platformIdHidTipKey, latestPlatformIdHidTip.current)
                onChange(item.value, item, extendItem)
                setVisible(false)
                dialog.destroy()
              }}
            >确定</Button>
          </span>
        </div>
      })
    } else {
      onChange(item.value, item, extendItem)
      setVisible(false)
    }
  }

  return <div className={styles.extendSelect} ref={domRef}>
    <div onClick={() => setVisible(!visible)}>
      <SelectDisplay
        placeholder={placeholder}
        onClear={onClear}
        options={options.concat([...config.values()].flat())}
        visible={false}
        value={value}
        allowClear={allowClear}
        displayTextClassName={displayTextClassName}
        className={className}
        displayStyle={displayStyle}
      />
    </div>
    {
      visible && <div
        className={classNames(styles.extendSelectOverlay, { [styles.open]: extendOpen })}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {
          _options.map(item => <div
            onClick={async () => {
              if (item.type === 'extend') {
                const _extendItem = configKeys.find(item => item.value === platformId)
                await _onChange(item, _extendItem)
              } else {
                onChange(item.value, item)
                setVisible(false)
              }
            }}
            className={classNames(styles.optionsItem, 'fill-white-bg', { [styles.active]: value === item.value })}
          >{item.label}</div>)
        }
        <div className={styles.optionsLine} />
        {
      extendOpen ? configKeys.map(extendItem => <div key={extendItem.value} className={classNames(styles.extendOptionsItemWrap)}>
        <div className={styles.extendOptionsItem}>
          <div className={styles.extendKeyLabel}>{extendItem.label}</div>
          <div className={styles.extendOptionsItemValues}>
            { config.get(extendItem.value).map(item => <div
              onClick={async () => {
                await _onChange(item, extendItem)
              }}
              className={classNames(styles.item, 'fill-white-bg', { [styles.active]: platformId === extendItem.value && item.value === value })}
            >{item.label}</div>)}</div>
        </div>
      </div>) : <div
        onClick={(e) => {
          e.stopPropagation()
          setExtendOpen(true)
        }}
        className={classNames(styles.extendOpenBtn, 'fill-white-bg')}
      >更多排序规则<Icon type="m-Vxing_xia" style={{ marginLeft: '4px' }} /></div>
    }
      </div>
    }
  </div>
}
